import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
//import { BrowserRouter, Route, Link } from 'react-router-dom';
import { Msg, Toast } from 'react-weui';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import TopNav from 'components/topNav';
import TodayIcon from '@material-ui/icons/Today';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';

import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import Http from 'services/http2';
import User from 'services/user2';
import CompanyService from 'services/company2';

import ReactEcharts from 'echarts-for-react';
import * as MobileActions from '../../actions';
import StatisticsFns from 'functions/statistics';

import Util from 'lib/util';

/*
/mp/statistics/purchase/order
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fstatistics%2Fpurchase%2Forder&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

const styles = theme => ({
  card: {
    margin: '10px 5px',
  },
  inputAdornment: {
    width: 18,
  },
});

const Config = {
  customerOrder: {
    title: '客户订单列表',
    apiPath: '/customerPurchase/detail',
    enumMainKey: 'B02_NCPo_Status',
    receiveStatusKey: 'B02_CPo_Delivery_Status',
    companyNameKey: 'innerCustomerName',
  },
  purchaseOrder: {
    title: '采购订单列表',
    apiPath: '/purchase/detail',
    enumMainKey: 'B02_NPo_Status',
    receiveStatusKey: 'B02_Po_Receive_Status',
    companyNameKey: 'innerVendorName',
  },
};

const ProdCategoryList = [
  {
    id: '-1',
    text: '请选择',
  },
  {
    id: '2000',
    text: 'ERP分类',
  },
  {
    id: '2001',
    text: '分类1',
  },
  {
    id: '2002',
    text: '分类2',
  },
  {
    id: '2003',
    text: '分类3',
  },
];

class StatisticsPurchaseOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      error: null,
      redirect: null,
      moreSign1: true,
      moreSign2: true,
      showIOS2: false,
      showToast: false,
      showLoading: false,

      showError: false,
      dateRange: [],
      rangeError: false,
      data: {},
      listDataDelay: [],
      listDataUpper: [],
      listDataDown: [],
      list: [],
      chartOpt1: {},
      chartOpt2: {},
      chartOpt3: {},
      currentTab: 0,
      unitNum: {},
      categoryType: '',
      categoryCodeSet: [],
    };
    this.companyCode = '';
    this.config = Config[props.type];
    this.isPurchase = props.type === 'purchaseOrder';
    this.type = '';
    this.dialogMsg = '';

    this.errorMsg = '';
    this.toastTimer = null;
    this.loadingTimer = null;
    this.errorTimer = null;

    this.listApiPath = '/statistical/poDeliveryStatis';
    this.yearItems = [];
    this.monthItems = [];
    this.currentMonth = 1;
    this.currentYear = 2018;
    this.searchQueries = {};
    this.rangeChange = this.rangeChange.bind(this);
    this.yearChange = this.yearChange.bind(this);
    this.monthChange = this.monthChange.bind(this);
    this.listData = []; //列表原始数据
    this.initProdCategoryList = [];
    this.subProdCategoryList = [];
  }

  init() {
    User.init(this.companyCode).then(response => {
      if (response.success) {
        this.companyCode = User.getCompanyCode();
        this.beforeInit().then(() => {
          this.search();
        });
        this.setState({ inited: true });
        this.getProdCategory();
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  //初始化默认日期范围
  async beforeInit() {
    //init date range
    let date = new Date();
    let now = Date.now();

    let year = date.getFullYear();
    let month = date.getMonth();
    for (let i = year; i >= 2018; i -= 1) {
      this.yearItems.push({ value: String(i), label: i });
    }
    for (let j = 1; j <= 12; j += 1) {
      this.monthItems.push({ value: String(j), label: j });
    }

    if (month === 0) {
      this.currentMonth = 12;
      this.currentYear = year - 1;
    } else {
      this.currentMonth = month;
      this.currentYear = year;
    }

    let mEnd = dayjs(now).endOf('day');
    let end = mEnd.format('YYYY-MM-DD');
    let begin = dayjs(end).subtract(3, 'months').format('YYYY-MM-DD');

    await this.setState({ dateRange: [begin, end] });
  }

  //日期范围改变
  rangeChange(i, e) {
    let value = e.target.value;
    this.setState({ rangeError: false });
    if (i === 0) {
      this.setState({ dateRange: [value, ''] });
      return;
    }
    let ts = Date.parse(value);
    let arr = this.state.dateRange.map(item => Date.parse(item));
    arr[i] = ts;
    let dateRange = [
      dayjs(arr[0]).format('YYYY-MM-DD'),
      dayjs(arr[1]).format('YYYY-MM-DD'),
    ];
    let delta = arr[1] - arr[0];
    if (delta >= 93 * 24 * 60 * 60 * 1000) {
      this.setState({ dateRange: dateRange, rangeError: true });
      return;
    }
    if (delta > 0) {
      this.setState({ dateRange: dateRange }, () => {
        this.search();
      });
    } else {
      this.setState({ dateRange: [value, value] });
    }
  }

  //年改变
  yearChange(event) {
    this.currentYear = Number(event.target.value);
    this.search();
  }

  //月份改变
  monthChange(event) {
    this.currentMonth = Number(event.target.value);
    this.search();
  }

  componentDidMount() {
    this.init();
  }

  hideDialog() {
    this.setState({
      showIOS2: false,
    });
  }

  //月份转日期范围
  setMonthParams() {
    let m = dayjs([this.currentYear, this.currentMonth]);

    // // @ApiModelProperty("期望交期开始日期")
    this.searchQueries.expectedDateStart = m.startOf('month').valueOf();

    // // // @ApiModelProperty("期望交期结束日期")
    // this.searchQueries.expectedDateEnd = m.endOf('month').valueOf();

    // m.subtract(1, 'months');

    // // @ApiModelProperty("前一次期望交期开始日期")
    // this.searchQueries.preExpectedDateStart =
    //   m.startOf('month').valueOf() - 43200000;

    // // @ApiModelProperty("前一次期望交期结束日期")
    // this.searchQueries.preExpectedDateEnd = m.endOf('month').valueOf();
  }

  getProdCategory() {
    CompanyService.getCustomizeCategory(this.companyCode, [
      '2000',
      '2001',
      '2002',
      '2003',
    ]).then(arr => {
      this.initProdCategoryList = arr;
    });
  }

  getSubProdCategoryList(categoryType) {
    if (Array.isArray(this.initProdCategoryList)) {
      this.subProdCategoryList = this.initProdCategoryList.filter(
        item => item.categoryType === categoryType
      );

      this.setState({ categoryCodeSet: [] });
    }
  }

  //搜索前参数注入
  beforeSearch() {
    if (this.state.currentTab === 0) {
      this.listApiPath = '/statistical/poDeliveryStatis';
      let arr = this.state.dateRange;
      this.searchQueries.expectedDateStart = undefined;
      this.searchQueries.expectedDateEnd = undefined;
      this.searchQueries.replyDateStart = Date.parse(arr[0]);
      this.searchQueries.replyDateEnd = Date.parse(arr[1]);
      this.searchQueries.excludeListDataFlag = 1;
    } else if (this.state.currentTab === 1) {
      this.listApiPath = '/statistical/poPriceStatis';
      this.searchQueries.replyDateStart = undefined;
      this.searchQueries.replyDateEnd = undefined;
      this.searchQueries.assessmentTimeType = 1;
      this.searchQueries.assessmentQuarterTime = 1;
      this.searchQueries.assessmentYearType = 3;
      this.searchQueries.assessmentYearTime = String(this.currentYear);
      this.searchQueries.assessmentMonthTime =
        this.currentMonth > 9
          ? String(this.currentMonth)
          : '0' + this.currentMonth;
      this.setMonthParams();
    }
    let { categoryType, categoryCodeSet } = this.state;
    this.searchQueries.categoryType = (Util.isEmpty(categoryType) || categoryType === '-1') ? undefined : categoryType;
    this.searchQueries.categoryCodeSet = Util.isEmpty(categoryCodeSet) ? undefined : categoryCodeSet;
  }

  search() {
    this.beforeSearch();
    let postbody = {
      ...this.searchQueries,
      groupOptFlag: 0,
      apiPath: this.listApiPath,
      companyCode: this.companyCode,
    };
    // Http.post('/api/cloudCenter', postbody).then(response => {
    //   if (response.success) {
    //     // let data = { ...response.data };
    //     // this.setState({ data: data });

    //     // if (this.state.currentTab === 0) {
    //     //   this.renderG0Bar();
    //     //   this.renderG0Pie(1);
    //     //   this.renderG0Pie(2);
    //     // } else if (this.state.currentTab === 1) {
    //     //   this.renderG1Bar(1);
    //     //   this.renderG1Bar(2);
    //     //   this.renderG1Pie();
    //     // }
    //   }
    // });
    if (this.state.currentTab === 0) {
      this.getTopDelayProductDeliveryStatis(postbody);
      this.getPoVendorDeliveryStatis(postbody);
      this.getProductDeliveryStatis(postbody);
    } else if (this.state.currentTab === 1) {
      this.getPriceIncrease(postbody);
      this.getPriceDecrease(postbody);
      this.getPriceSummary(postbody);
    }
    //小数位获取
    CompanyService.getDecimalPlaceByCodes(this.companyCode).then(rs => {
      let obj = {};
      for (let code in rs) {
        obj[code] = rs[code];
      }
      this.setState({ unitNum: obj });
    });
  }

  /************* currNavTab === 0 begin *****************/

  // 前十名欠料物料（按百分比）
  getTopDelayProductDeliveryStatis(postbody) {
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter', {
      ...postbody,
      apiPath: '/statistical/getTopDelayProductDeliveryStatis',
    }).then(response => {
      this.setState({ showLoading: false });
      if (response.success && response.data) {
        this.setState({ listDataDelay: response.data.listDataDelay }, () => {
          this.renderG0Bar();
        });
      }
    });
  }
  // 采购达成分析（按供应商）
  getPoVendorDeliveryStatis(postbody) {
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter', {
      ...postbody,
      apiPath: '/statistical/getPoVendorDeliveryStatis',
    }).then(response => {
      this.setState({ showLoading: false });
      if (response.success && response.data) {
        let data = response.data;
        let stateData = this.state.data;
        this.setState(
          {
            data: {
              ...stateData,
              delayDateVendor: data.delayDateVendor,
              delayQtyVendor: data.delayQtyVendor,
              notDeliveryQtyVendor: data.notDeliveryQtyVendor,
              ontimeVendor: data.ontimeVendor,
            },
          },
          () => {
            this.renderG0Pie(1);
          }
        );
      }
    });
  }
  // 采购达成分析（按物料）
  getProductDeliveryStatis(postbody) {
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter', {
      ...postbody,
      apiPath: '/statistical/getProductDeliveryStatis',
    }).then(response => {
      this.setState({ showLoading: false });
      if (response.success && response.data) {
        let data = response.data;
        let stateData = this.state.data;
        this.setState(
          {
            data: {
              ...stateData,
              delayDateProd: data.delayDateProd,
              notDeliveryProd: data.notDeliveryProd,
              ontimeProd: data.ontimeProd,
              partDeliveryProd: data.partDeliveryProd,
            },
          },
          () => {
            this.renderG0Pie(2);
          }
        );
      }
    });
  }

  //渲染柱图
  renderG0Bar() {
    let listDataDelay = this.state.listDataDelay || [];
    let data = [];
    let arrProd = [];
    listDataDelay.forEach(item => {
      data.push((item.delayPercent * 100).toFixed(1));
      arrProd.push(item.productCode);
    });
    for (let i = data.length; i < 10; i += 1) {
      data.push('');
      arrProd.push('');
    }
    this.setState({ chartOpt1: StatisticsFns.genBarOpt(arrProd, data) });
  }

  //渲染饼图
  renderG0Pie(type) {
    let {
      delayDateVendor,
      delayQtyVendor,
      ontimeVendor,
      delayDateProd,
      delayQtyProd,
      notDeliveryProd,
      ontimeProd,
    } = this.state.data;
    //let legendData = ['准时交货', '延误交货', '交货欠料'];
    let data = [
      { value: ontimeVendor, name: '准时交货' },
      { value: delayDateVendor, name: '延误交货' },
      { value: delayQtyVendor, name: '交货欠料' },
    ];
    let seriesName = '按供应商';

    if (type === 2) {
      seriesName = '按物料';
      //legendData = ['准时交货', '延误交货', '交货不足', '未交货'];
      data = [
        { value: ontimeProd, name: '准时交货' },
        { value: delayDateProd, name: '延误交货' },
        { value: delayQtyProd, name: '交货不足' },
        { value: notDeliveryProd, name: '未交货' },
      ];
    }
    let option = StatisticsFns.genPieBarOpt(seriesName, data);
    if (type === 1) {
      this.setState({ chartOpt2: option });
    } else {
      this.setState({ chartOpt3: option });
    }
  }

  /************* currNavTab === '1' begin *****************/

  // 单价提升物料分析
  getPriceIncrease(postbody) {
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter', {
      ...postbody,
      apiPath: '/statistical/price/increase',
    }).then(response => {
      this.setState({ showLoading: false });
      if (response.success && response.data) {
        this.setState({ listDataUpper: response.data.listDataUpper }, () => {
          this.renderG1Bar(1);
        });
      }
    });
  }
  // 单价降低物料分析
  getPriceDecrease(postbody) {
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter', {
      ...postbody,
      apiPath: '/statistical/price/decrease',
    }).then(response => {
      this.setState({ showLoading: false });
      if (response.success && response.data) {
        this.setState({ listDataDown: response.data.listDataDown }, () => {
          this.renderG1Bar(2);
        });
      }
    });
  }
  // 采购价格分析
  getPriceSummary(postbody) {
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter', {
      ...postbody,
      apiPath: '/statistical/price/summary',
    }).then(response => {
      this.setState({ showLoading: false });
      if (response.success && response.data) {
        let data = response.data;
        let stateData = this.state.data;
        this.setState(
          {
            data: {
              ...stateData,
              downPrice: data.downPrice,
              equalPrice: data.equalPrice,
              upperPrice: data.upperPrice,
            },
          },
          () => {
            this.renderG1Pie();
          }
        );
      }
    });
  }

  //渲染柱图
  renderG1Bar(type) {
    let listDataDelay = this.state.listDataUpper || [];
    let data = [];
    let arrProd = [];
    if (type === 2) {
      listDataDelay = this.state.listDataDown || [];
    }
    listDataDelay.forEach(item => {
      data.push((Math.abs(item.avgPriceChange) * 100).toFixed(1));
      arrProd.push(item.productCode);
    });
    for (let i = data.length; i < 10; i += 1) {
      data.push('');
      arrProd.push('');
    }
    if (type === 1) {
      this.setState({
        chartOpt1: StatisticsFns.genBarOpt(
          arrProd,
          data,
          ['rgb(211,80,88)'],
          null
        ),
      });
    } else {
      this.setState({
        chartOpt2: StatisticsFns.genBarOpt(arrProd, data, ['rgb(9,78,119)']),
      });
    }
  }

  //渲染饼图
  renderG1Pie() {
    let { downPrice, equalPrice, upperPrice } = this.state.data;
    let data = [
      { value: downPrice, name: '降价' },
      { value: equalPrice, name: '持平' },
      { value: upperPrice, name: '涨价' },
    ];
    let seriesName = '按供应商';
    this.setState({ chartOpt3: StatisticsFns.genPieBarOpt(seriesName, data) });
  }

  /************* currNavTab === '1' end *****************/

  errorFn(errorMsg) {
    this.errorMsg = errorMsg;
    this.setState({ showLoading: false });
    this.setState({ showError: true });
    this.errorTimer = setTimeout(() => {
      this.setState({ showError: false });
    }, 3000);
  }

  componentWillUnmount() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
    if (this.errorTimer) {
      clearTimeout(this.errorTimer);
    }
  }

  handleTab(e, index) {
    this.setState(
      {
        currentTab: index,
        data: {},
        list: [],
        showLoading: true,
        categoryType: '',
        categoryCodeSet: [],
      },
      () => {
        this.search();
      }
    );
  }

  //前端搜索过滤
  handleSearch(key, e) {
    // let arrSearchField = [
    //   'productCode',
    //   'productName',
    //   'productScale',
    //   'innerVendorCode',
    //   'innerVendorName',
    // ]; //搜索字段
    // let searchKey = key;
  }

  handleSelectChange = event => {
    let value = event.target.value;
    let key = event.target.name;

    if (key === 'categoryType') {
      this.getSubProdCategoryList(value);
    }

    this.setState({ [key]: value }, () => {
      this.search();
    });
  };

  render() {
    const { classes } = this.props;
    //const { data, actions } = this.props;
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }

    if (this.state.redirect !== null) {
      return <Redirect to={this.state.redirect} />;
    }
    //const unitNum = this.state.unitNum;

    return (
      <div>
        <Paper square={true} style={{ marginBottom: '5px' }}>
          <TopNav inited={this.state.inited} />
          <Tabs
            value={this.state.currentTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.handleTab.bind(this)}
          >
            <Tab label="采购订单达成分析" />
            <Tab label="采购价格分析" />
          </Tabs>
        </Paper>

        {this.state.currentTab === 0 && (
          <div>
            {this.state.dateRange.length === 2 && (
              <div style={{ padding: '10px 5px', marginTop: 10 }}>
                <TextField
                  label="起始日期"
                  variant="outlined"
                  margin="dense"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        className={classes.inputAdornment}
                      >
                        <TodayIcon />
                      </InputAdornment>
                    ),
                  }}
                  type="date"
                  value={this.state.dateRange[0]}
                  onChange={e => this.rangeChange(0, e)}
                />
                <TextField
                  style={{ marginLeft: 5 }}
                  label="结束日期"
                  variant="outlined"
                  margin="dense"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        className={classes.inputAdornment}
                      >
                        <TodayIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={this.state.rangeError}
                  helperText={
                    this.state.rangeError ? '查询范围最大不得超过三个月' : ''
                  }
                  type="date"
                  value={this.state.dateRange[1]}
                  onChange={e => this.rangeChange(1, e)}
                />
              </div>
            )}
          </div>
        )}

        {this.state.currentTab === 1 && (
          <div>
            <div style={{ padding: '10px 5px', marginTop: 10 }}>
              <TextField
                select
                label="年"
                variant="outlined"
                style={{ marginLeft: 15, width: 80 }}
                defaultValue={this.currentYear}
                onChange={e => {
                  this.yearChange(e);
                }}
                SelectProps={{
                  native: true,
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                margin="dense"
              >
                {this.yearItems.map(item => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </TextField>

              <TextField
                select
                label="月"
                variant="outlined"
                style={{ marginLeft: 15, width: 80 }}
                defaultValue={this.currentMonth}
                onChange={e => {
                  this.monthChange(e);
                }}
                SelectProps={{
                  native: true,
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                margin="dense"
              >
                {this.monthItems.map(item => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </TextField>
            </div>
          </div>
        )}

        <div className="form-advanced-item">
          <p>物料分类</p>
          <div className="select-group">
            <FormControl className="select-group-item">
              {/* <InputLabel htmlFor="categoryType">物料分类</InputLabel> */}
              <Select
                value={this.state.categoryType}
                onChange={this.handleSelectChange}
                inputProps={{
                  name: 'categoryType',
                  id: 'categoryType',
                }}
              >
                {ProdCategoryList.map(item => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl className="select-group-item">
              {/* <InputLabel htmlFor="select-multiple-checkbox">分类编码</InputLabel> */}
              <Select
                multiple
                value={this.state.categoryCodeSet}
                onChange={this.handleSelectChange}
                input={<Input id="select-multiple-checkbox" />}
                renderValue={selected => {
                  let names = selected.join(', ');
                  let arr = this.subProdCategoryList.filter(row => selected.includes(row.id)).map(row => row.categoryName);
                  if (arr.length) {
                    names = arr.join(', ');
                  }
                  return names;
                }}
                name='categoryCodeSet'
              >
                {this.subProdCategoryList.map(item => (
                  <MenuItem key={item.id} value={item.id}>
                    <Checkbox
                      checked={this.state.categoryCodeSet.includes(item.id)}
                    />
                    <ListItemText primary={item.text} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        {this.state.currentTab === 0 && (
          <div>
            <Card className={classes.card}>
              <CardHeader title="前十名欠料物料（按百分比）" />
              <Divider />
              <CardContent style={{ padding: '20px' }}>
                <ReactEcharts
                  option={this.state.chartOpt1}
                  notMerge={true}
                  lazyUpdate={true}
                />
              </CardContent>
            </Card>

            <Card className={classes.card}>
              <CardHeader
                classes={{ title: classes.title }}
                title="采购达成分析（按供应商）"
              />
              <Divider />
              <CardContent style={{ padding: '10px' }}>
                <ReactEcharts
                  option={this.state.chartOpt2}
                  notMerge={true}
                  lazyUpdate={true}
                />
              </CardContent>
            </Card>

            <Card className={classes.card}>
              <CardHeader
                classes={{ title: classes.title }}
                title="采购达成分析（按物料）"
              />
              <Divider />
              <CardContent style={{ padding: '10px' }}>
                <ReactEcharts
                  option={this.state.chartOpt3}
                  notMerge={true}
                  lazyUpdate={true}
                />
              </CardContent>
            </Card>

            {/* <Card className={classes.card}>
              <CardHeader classes={{ title: classes.title }} title="物料明细" />
              <Divider />
              <div style={{ padding: '0 10px', marginTop: '20px' }}>
                <SearchBar
                  placeholder="供应商名称/编码 产品名称/编码/规格"
                  onSubmit={this.handleSearch.bind(this)}
                  onClear={this.handleSearch.bind(this)}
                />
              </div>
              <CardContent style={{ padding: '10px' }}>
                <div className="order-detail-list">
                  <ul>
                    {this.state.list.map((item, index) => (
                      <li
                        className="order-detail-item"
                        key={String(item.id) + index}
                      >
                        <div className="clearfix">
                          <span className="fl u-lineNo">{index + 1}</span>
                          <div style={{ overflow: 'hidden' }}>
                            <h4>
                              {item.productCode} - {item.productName}
                            </h4>
                            <p className="mb10">{item.productScale}</p>
                          </div>
                        </div>
                        <ul className="clearfix">
                          <li className="single">
                            供应商编码：{item.innerVendorCode}
                          </li>
                          <li className="single">
                            供应商名称：{item.innerVendorName}
                          </li>
                          <li className="single">
                            采购单号（项次）：{item.poErpNo}（
                            {item.poLineNoShow}）
                          </li>
                          <li>
                            采购交期：
                            {item.expectedDate
                              ? formatDate(item.expectedDate)
                              : '--'}
                          </li>
                          <li>
                            采购数量：
                            <span className="blue">
                              {item.purchaseQty
                                ? formatNumber(
                                    item.purchaseQty,
                                    unitNum.Quantity_Decimal_Place
                                  )
                                : '--'}
                            </span>
                          </li>
                          <li>
                            答交交期：
                            {item.answerDate
                              ? formatDate(item.answerDate)
                              : '--'}
                          </li>
                          <li>
                            答交数量：
                            {item.totalAnswerQty
                              ? formatNumber(
                                  item.totalAnswerQty,
                                  unitNum.Quantity_Decimal_Place
                                )
                              : '--'}
                          </li>
                          <li>
                            收货日期：
                            {item.erpReceiveDate
                              ? formatDate(item.erpReceiveDate)
                              : '--'}
                          </li>
                          <li>
                            收货数量：
                            {item.totalReceiveQty
                              ? formatNumber(
                                  item.totalReceiveQty,
                                  unitNum.Quantity_Decimal_Place
                                )
                              : '--'}
                          </li>
                          <li>
                            入库日期：
                            {item.erpStorageDate
                              ? formatDate(item.erpStorageDate)
                              : '--'}
                          </li>
                          <li>
                            入库数量：
                            {item.totalIncomingQty
                              ? formatNumber(
                                  item.totalIncomingQty,
                                  unitNum.Quantity_Decimal_Place
                                )
                              : '--'}
                          </li>
                          <li>
                            验退数量：
                            {item.totalReturnQty
                              ? formatNumber(
                                  item.totalReturnQty,
                                  unitNum.Quantity_Decimal_Place
                                )
                              : '--'}
                          </li>
                          <li>
                            仓退数量：
                            {item.totalExchangeQty
                              ? formatNumber(
                                  item.totalExchangeQty,
                                  unitNum.Quantity_Decimal_Place
                                )
                              : '--'}
                          </li>
                          <li>
                            欠料数量：
                            <span className="red">
                              {item.delayQty
                                ? formatNumber(
                                    item.delayQty,
                                    unitNum.Quantity_Decimal_Place
                                  )
                                : '--'}
                            </span>
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                  {this.state.list.length === 0 && (
                    <p className="no-data"> -- 暂无数据 -- </p>
                  )}
                </div>
              </CardContent>
            </Card> */}
          </div>
        )}

        {this.state.currentTab === 1 && (
          <div>
            <Card className={classes.card}>
              <CardHeader title="单价提升物料分析" />
              <Divider />
              <CardContent style={{ padding: '20px' }}>
                <ReactEcharts
                  option={this.state.chartOpt1}
                  notMerge={true}
                  lazyUpdate={true}
                />
              </CardContent>
            </Card>

            <Card className={classes.card}>
              <CardHeader title="单价降低物料分析" />
              <Divider />
              <CardContent style={{ padding: '20px' }}>
                <ReactEcharts
                  option={this.state.chartOpt2}
                  notMerge={true}
                  lazyUpdate={true}
                />
              </CardContent>
            </Card>

            <Card className={classes.card}>
              <CardHeader title="采购价格分析" />
              <Divider />
              <CardContent style={{ padding: '20px' }}>
                <ReactEcharts
                  option={this.state.chartOpt3}
                  notMerge={true}
                  lazyUpdate={true}
                />
              </CardContent>
            </Card>

            {/* <Card className={classes.card}>
              <CardHeader classes={{ title: classes.title }} title="物料明细" />
              <Divider />
              <div style={{ padding: '0 10px', marginTop: '20px' }}>
                <SearchBar
                  placeholder="供应商名称/编码 产品名称/编码/规格"
                  onSubmit={this.handleSearch.bind(this)}
                  onClear={this.handleSearch.bind(this)}
                />
              </div>
              <CardContent style={{ padding: '10px' }}>
                <div className="order-detail-list">
                  <ul>
                    {this.state.list.map((item, index) => (
                      <li
                        className="order-detail-item"
                        key={String(item.id) + index}
                      >
                        <div className="clearfix">
                          <span className="fl u-lineNo">{index + 1}</span>
                          <div style={{ overflow: 'hidden' }}>
                            <h4>
                              {item.productCode} - {item.productName}
                            </h4>
                            <p className="mb10">{item.productScale}</p>
                          </div>
                        </div>
                        <ul className="clearfix">
                          <li className="single">
                            供应商编码：{item.innerVendorCode}
                          </li>
                          <li className="single">
                            供应商名称：{item.innerVendorName}
                          </li>
                          <li>
                            上月采购数量：
                            {formatNumber(
                              item.prePurchaseQty,
                              unitNum.Quantity_Decimal_Place
                            )}
                          </li>
                          <li>
                            本月采购数量：
                            {formatNumber(
                              item.purchaseQty,
                              unitNum.Quantity_Decimal_Place
                            )}
                          </li>
                          <li>
                            上月采购金额：
                            {formatNumber(
                              item.preAmount,
                              unitNum.Amount_Decimal_Place
                            )}
                          </li>
                          <li>
                            本月采购金额：
                            {formatNumber(
                              item.amount,
                              unitNum.Amount_Decimal_Place
                            )}
                          </li>
                          <li>
                            上月平均单价：
                            {item.preAvgPrice !== null
                              ? formatNumber(
                                  item.preAvgPrice,
                                  unitNum.Price_Decimal_Place
                                )
                              : '--'}
                          </li>
                          <li>
                            本月平均单价：
                            {formatNumber(
                              item.avgPrice,
                              unitNum.Price_Decimal_Place
                            )}
                          </li>
                          <li>
                            金额变动：
                            {formatNumber(item.amountChange * 100, '0,0.0')}%
                          </li>
                          <li>
                            价格变动：
                            <span className={item.priceColor}>
                              {item.avgPriceChange !== null
                                ? formatNumber(
                                    item.avgPriceChange * 100,
                                    '0,0.0'
                                  ) + '%'
                                : '--'}
                            </span>
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              </CardContent>
            </Card> */}
          </div>
        )}

        <Toast icon="warn" show={this.state.showError}>
          {this.errorMsg}
        </Toast>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

StatisticsPurchaseOrder.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StatisticsPurchaseOrder));
